function MapContactScreen() {
  return (
    <section className="mt-5 relative h-[500px] w-full py-5" data-mapbox>
      <figure className="h-full">
        <iframe
          title="map"
          className="w-full h-full overflow-hidden rounded-lg filter hue-rotate-60"
          loading="lazy"
          src="https://maps.google.com/maps?width=100%25&amp;height=500&amp;hl=en&amp;q=1344%20Wyandotte%20Street%20East+(Sharan%20Sukesh)&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        ></iframe>
      </figure>
    </section>
  );
}

export default MapContactScreen;
